// extracted by mini-css-extract-plugin
module.exports = {"top":"i_A","bottom":"i_B","left":"i_C","right":"i_D"};